import { createFileRoute } from "@tanstack/react-router";
import { Shell } from "@/components/control-tower/Layout";
import { PerspectiveHero } from "@/components/control-tower/PerspectiveHero";
import { DataQualitySection } from "@/components/control-tower/perspectives/DataQualitySection";

export const Route = createFileRoute("/data-quality")({
  component: DataQualityPage,
});

// Datan laatu — data-quality judgment lens (story #850). Owns
// Finding.category = "data_quality". Building scope is the live workspace, no
// Yhteenveto/Havainnot/Tapahtumaloki topic tabs.
function DataQualityPage() {
  return (
    <Shell title="Datan laatu" subtitle="Signaalien laatu ja luotettavuus">
      <div className="space-y-6">
        <PerspectiveHero perspectiveId="data-quality" />
        <DataQualitySection />
      </div>
    </Shell>
  );
}
